export const BASE_URL = process.env.NEXT_PUBLIC_BASE_URL;
export const COUNTRY_CODE = process.env.NEXT_PUBLIC_COUNTRY_CODE;
export const LOCAL_HOST_ADDRESS = "localhost:3000";
export const HOST =
  process.env.NODE_ENV === "production"
    ? process.env.NEXT_PUBLIC_BASE_PATH
    : `http://${LOCAL_HOST_ADDRESS}`;
export const SUPABASE_URL = process.env.NEXT_PUBLIC_SUPABASE_URL;
export const SUPABASE_ANON_KEY = process.env.NEXT_PUBLIC_SUPABASE_ANON_KEY;
